<template>
    <div class="bg-white p-3 radius-8 mt-3 serviceRequest__panel">
        <div class="row gy-4">
            <div
                v-for="(column, colIndex) in isoColumns"
                :key="'iso-col-' + colIndex"
                :class="columnClass"
            >
                <ul class="listItem serviceRequest__listItem">
                    <li v-for="child in column" :key="child.id">
                        <div class="form-check">
                            <label class="form-check-label">{{ child.checkbox_value }}</label>
                            <input
                                class="form-check-input"
                                type="checkbox"
                                :id="'iso-' + child.id"
                                v-model="responses.checkboxes[child.checkbox_value]"
                            />
                        </div>
                    </li>
                </ul>
            </div>

            <div v-if="auditCheckboxes.length" :class="columnClass">
                <ul class="listItem serviceRequest__listItem">
                    <li class="serviceRequest__listHeading">Type of Audit</li>
                    <li v-for="child in auditCheckboxes" :key="child.id">
                        <div class="form-check">
                            <label class="form-check-label">{{ child.checkbox_value }}</label>
                            <input
                                class="form-check-input"
                                type="checkbox"
                                :id="'audit-' + child.id"
                                v-model="responses.checkboxes[child.checkbox_value]"
                            />
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
    service: Object,
    responses: Object
})

const checkboxList = computed(() => {
    if (Array.isArray(props.service?.service_checkbox)) {
        return props.service.service_checkbox
    }

    return Object.values(props.service?.service_checkbox || {})
})

const findCheckboxChildren = (key) => {
    const item = checkboxList.value.find(checkbox => checkbox.checkbox_value === key)
    if (!item) return []

    return Array.isArray(item.children)
        ? item.children
        : Object.values(item.children || {})
}

const isoCheckboxes = computed(() => findCheckboxChildren('isoCheckboxes'))
const auditCheckboxes = computed(() => findCheckboxChildren('auditCheckboxes'))

const isoColumns = computed(() => {
    const items = isoCheckboxes.value

    if (!items.length) return []
    if (items.length === 1) return [items]

    const midpoint = Math.ceil(items.length / 2)
    const firstColumn = items.slice(0, midpoint)
    const secondColumn = items.slice(midpoint)

    return secondColumn.length ? [firstColumn, secondColumn] : [firstColumn]
})

const columnClass = computed(() => {
    const totalColumns = isoColumns.value.length + (auditCheckboxes.value.length ? 1 : 0)

    if (totalColumns <= 1) return 'col-12'
    if (totalColumns === 2) return 'col-lg-6 col-md-6'
    return 'col-lg-4 col-md-6'
})
</script>
